import { styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledLoadingContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
			align-items: center;
			display: flex;
			flex-direction: column;
			gap: ${theme.size.static450};
			height: 60svh;
			justify-content: center;
		`;
  }}
`;
